import axios from "axios";

const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const URL = `${BASE}/api/servicios/ordenes`;

function norm(o) {
  return {
    ordenTrabajoId: o.ordenTrabajoId ?? o.OrdenTrabajoId,
    fechaEntrada:   o.fechaEntrada   ?? o.FechaEntrada,
    fechaEntrega:   o.fechaEntrega   ?? o.FechaEntrega,
    cliente:        o.cliente        ?? o.Cliente        ?? "",
    nombreCliente:  o.nombreCliente  ?? o.NombreCliente  ?? "",
    contacto:       o.contacto       ?? o.Contacto       ?? "",
    trabajo:        o.trabajo        ?? o.Trabajo        ?? "",
    status:         o.status         ?? o.Status         ?? "A",
    precioEstimado: o.precioEstimado ?? o.PrecioEstimado ?? null,
    iva:            o.iva            ?? o.Iva            ?? null,
    total:          o.total          ?? o.Total          ?? null,
    tieneFirma:     o.tieneFirma     ?? o.TieneFirma     ?? false,
    firmaImagen:    o.firmaImagen    ?? o.FirmaImagen    ?? null,
    fechaFirma:     o.fechaFirma     ?? o.FechaFirma     ?? null,
    foto1:          o.foto1          ?? o.Foto1          ?? null,
    foto2:          o.foto2          ?? o.Foto2          ?? null,
    foto3:          o.foto3          ?? o.Foto3          ?? null,
  };
}

export async function obtenerOrdenes(search = "") {
  const r = await axios.get(URL, { params: search ? { search } : {} });
  return (r.data ?? []).map(norm);
}

export async function obtenerOrden(id) {
  const r = await axios.get(`${URL}/${id}`);
  return norm(r.data);
}

export async function siguienteFolio() {
  const r = await axios.get(`${URL}/siguiente-folio`);
  return r.data?.folio ?? 1;
}

export async function crearOrden(dto) {
  const r = await axios.post(URL, dto);
  return r.data;
}

export async function actualizarOrden(id, dto) {
  await axios.put(`${URL}/${id}`, dto);
}

export async function cancelarOrden(id) {
  await axios.delete(`${URL}/${id}`);
}

export async function guardarFirma(id, firmaImagen) {
  await axios.post(`${URL}/${id}/firma`, { firmaImagen });
}
